import { CIMSModule, CIMSPage, Permission } from 'shared'
import { useProtectedMenuItem } from './useProtectedMenuItem'
import { BugOutlined } from '@ant-design/icons'
import { useGlobalState } from '../../../../context/GlobalStateContext'

export function useDev() {
  const {
    state: { projectGlobalId },
  } = useGlobalState()
  const item = useProtectedMenuItem({
    module: CIMSModule.Developer,
    pages: [
      {
        page: CIMSPage.Developers,
        permission: 'developer',
      },
      {
        page: CIMSPage.DeveloperSnapshots,
        permission: 'developer',
      },
      {
        page: CIMSPage.UserSync,
        permission: Permission.SyncUsers,
      },
    ],
    icon: <BugOutlined />,
  })
  if (projectGlobalId) return null
  return item
}
